import { LogLevel } from '../domain/types';

const LOG_LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
};

/**
 * Determines if a log entry should be captured based on the configured log level
 * @param entryLevel The level of the log entry being checked
 * @param configuredLevel The minimum log level configured in the SDK
 * @returns true if the entry should be captured, false otherwise
 */
export function shouldCapture(entryLevel: LogLevel, configuredLevel: LogLevel): boolean {
  return LOG_LEVEL_PRIORITY[entryLevel] >= LOG_LEVEL_PRIORITY[configuredLevel];
}

/**
 * Determines the appropriate log level for different event types
 */
export function getEventLogLevel(eventType: string, eventData?: any, entryLevel?: LogLevel): LogLevel {
  switch (eventType) {
    case 'console':
      // Console errors and warnings are already filtered in ConsoleCapture
      // Use the actual entry level since ConsoleCapture sets it correctly
      return entryLevel || 'warn';
      
    case 'network':
      // Network errors (4xx/5xx status codes)
      return 'error';
      
    case 'navigation':
      // Page navigation events - info level
      return 'info';
      
    case 'performance':
      // Performance metrics - assign based on rating and metric type
      if (eventData?.rating === 'poor') return 'error';
      if (eventData?.rating === 'needs-improvement') return 'warn';
      // Most performance metrics are debug level unless they indicate problems
      return 'debug';
      
    case 'interaction':
      // User interactions - info level by default
      return 'info';
      
    case 'visibility':
      // Focus/blur events - debug level (noisy)
      return 'debug';
      
    case 'resource':
      // Resource loading - info level
      return 'info';
      
    default:
      return 'info';
  }
}